<template>
  <div class="app-container calendar-list-container">
      <avue-crud :data="comworkerData" :option="tableoption" :page="page" @size-change="sizeChange" @current-change="currentChange" @search-reset="searchReset" @row-click="showRow" @search-change="searchChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button class="filter-item" size="mini" @click="addemployee" type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button class="filter-item" size="mini" @click="editemployee" type="primary" icon="el-icon-edit-outline" :disabled = "derail">编辑
          </el-button>
          <el-button class="filter-item" size="mini" @click="ygingo" type="primary" icon="el-icon-view"  :disabled = "derail">查看
          </el-button>
          <el-button class="filter-item" size="mini" @click="agreecompamy" type="primary" icon="el-icon-circle-close-outline"  :disabled = "coldderail">同意
          </el-button>
          <el-button class="filter-item" size="mini" @click="noagreecompamy" type="primary" icon="el-icon-circle-check-outline"  :disabled = "coldderail">拒绝
          </el-button>
        </template>
        <template slot-scope="scope" slot="id">
            <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
        </template>
      </avue-crud>
      <personnelinfo ref="childinfo" @refresh="refresh"></personnelinfo>
      <personedit ref="childedit" @refresh="refresh"></personedit>
  </div>
</template>
<script>
import {getWorkerInfo} from '@/api/admin/business'
import {getObj} from '@/api/admin/workerUser'
import {addcompany} from '@/api/admin/user'
import {getImgLink} from '@/config/env'
import { objKeySort } from '@/util/ajaxsign'
import { dealElement } from '@/util/util'
import {personnel} from '@/const/asset/user'
import personnelinfo from './personnelinfo.vue'
import personedit from './personedit.vue'
export default {
    components: {personnelinfo,personedit},
  data() {
    return {
      tableoption : personnel,
      derail : true,
      coldderail : true,
      infodetail : {},
      companydata : {},
      admins : '',
      radio:'',
      comStart:false, //冻结
      comStop:false,  // 解冻
      // 企业员工数据
      comworkerData:[],
      comworkerId:'',
      search : {},
      form : {},
      page: {
        pageSizes: [10, 20, 50, 100],
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      state:''
    }
  },
  created(){
    this.getstate()
    this.getworker()
  },
  methods: {
    refresh(){
      this.getworker();
      this.radio = undefined;
      this.derail = true;
      this.coldderail = true;
    },
    //获取企业信息
    getstate(){
        this.companydata=JSON.parse(sessionStorage.getItem('userInfo'));
        console.log(this.companydata);
        if(this.companydata.companyId == this.companydata.company.id){
            this.admins = true;
        }else{
             this.admins = false;
        }
    },
    showRow(row){
      this.infodetail = row;
      this.radio = row.id;
      this.derail =false;
      console.log(row.id)
      if(row.companyAuthStatus !=1 && row.companyAuthStatus !=-1){
        this.coldderail = false;
      }else{
        this.coldderail = true;
      }
    },
    //获取员工数据
    getworker(){
      //获取企业员工列表
      let that=this
        var companyId=JSON.parse(sessionStorage.getItem('userInfo')).companyId;
        that.search = {
        pageNum : that.page.currentPage,
        pageSize : that.page.pageSize,
        companyId:companyId,
        state:that.state
      }
        getWorkerInfo(objKeySort(dealElement(that.search))).then(response =>{
            that.comworkerData=response.data.data.rows;
            that.page.total = response.data.data.total;
        })
    },
    //条数
    sizeChange(val) {
      this.page.pageSize = val;
      this.getworker();
    },
    //页码
    currentChange(val) {
      this.page.currentPage = val;
      this.getworker();
    },
     //清空
    searchReset(){
      this.page.currentPage = 1;
      this.page.pageSize = 20;
      this.getworker();
    },
    //搜索数据
    searchChange(params){
      let that=this
      that.state=params.status
      this.getworker();
    },

    //添加员工
    addemployee(){
      this.$refs.childedit.setsataus(undefined,'添加员工');
    },

    //编辑员工
    editemployee(){
       this.$refs.childedit.setsataus(this.radio,'编辑员工');
    },
    //同意加入
    agreecompamy(){
      addcompany(objKeySort({userId:this.radio,state : 1})).then(response =>{
          this.refresh()
      })
    },

    //拒绝加入
    noagreecompamy(){
      addcompany(objKeySort({userId:this.radio,state : 0})).then(response =>{
          this.refresh()
      })
    },
    //查看详情
    ygingo() {
      this.$refs.childinfo.setsataus(this.radio,this.infodetail);
    },

  }
}
</script>
